import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { bigEnterpriseGovernment, emailAddressGovernment, thanksGovernment } from './government-employee-steps'

export const governmentEmployeeScenarioA: Scenario = {
  id: 'government-employee-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.GOVERNMENT_EMPLOYEE,
  version: '1',
  milestones: [emailAddressGovernment.id, bigEnterpriseGovernment.id, thanksGovernment.id],
  steps: [emailAddressGovernment, bigEnterpriseGovernment, thanksGovernment],
  weight: 1,
}
